import React, { useEffect, useState } from "react";
import { aggregateGrowthData } from "../helpers";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";

export const useGetData = () => {
  const { data: subscribersGrowth, isLoading: subscribersGrowthLoading } =
    UseApiCallForOldDashboardData({
      url: "growth_per_sport",
      method: "POST",
      body: {
        data: "none",
      },
    });

  const [aggregatedMonthsData, setAggregatedMonthsData] = useState([]);

  useEffect(() => {
    if (!subscribersGrowth) return;
    setAggregatedMonthsData(aggregateGrowthData(subscribersGrowth));
  }, [subscribersGrowth]);

  // function to find max value in the array..
  const maxValue = aggregatedMonthsData.reduce((maxValue, state) => {
    const array = Object.values(state)
      ?.slice(1)
      .reduce((emptyArray, state) => {
        return [...emptyArray, ...Object.values(state)];
      }, []);

    const maxValueInArr = Math.max(...array);

    maxValue = maxValue > maxValueInArr ? maxValue : maxValueInArr;

    return maxValue;
  }, 0);

  return {
    maxValue,
    subscribersGrowth,
    subscribersGrowthLoading,
    aggregatedMonthsData,
  };
};
